export function StatBlock({
  label,
  value,
  highlight,
}: {
  label: string;
  value: string | number;
  highlight?: boolean;
}) {
  return (
    <div className="p-3 rounded-lg bg-slate-900/60 border border-slate-700">
      <p className="text-[10px] uppercase tracking-wider text-slate-500 mb-1">
        {label}
      </p>
      <p
        className={`text-lg font-mono font-semibold ${
          highlight ? 'text-red-400' : 'text-white'
        }`}
      >
        {value}
      </p>
    </div>
  );
}
